import DashboardIcon from '@mui/icons-material/Dashboard';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import HistoryIcon from '@mui/icons-material/History';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import PrintIcon from '@mui/icons-material/Print';
import PersonIcon from '@mui/icons-material/Person';
import SpaIcon from '@mui/icons-material/Spa';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupIcon from '@mui/icons-material/Group';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GrassIcon from '@mui/icons-material/Grass';
import BusinessIcon from '@mui/icons-material/Business';
import LinkIcon from '@mui/icons-material/Link';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import DescriptionIcon from '@mui/icons-material/Description';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import FolderIcon from '@mui/icons-material/Folder';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BackupIcon from '@mui/icons-material/Backup';
import GetAppIcon from '@mui/icons-material/GetApp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import TerminalIcon from '@mui/icons-material/Terminal';
import StorageIcon from '@mui/icons-material/Storage';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import BuildIcon from '@mui/icons-material/Build';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import PaletteIcon from '@mui/icons-material/Palette';
import HubIcon from '@mui/icons-material/Hub';
import PsychologyIcon from '@mui/icons-material/Psychology';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import DevicesIcon from '@mui/icons-material/Devices';
import TimelineIcon from '@mui/icons-material/Timeline';
import ScaleIcon from '@mui/icons-material/Scale';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import InsightsIcon from '@mui/icons-material/Insights';

import { temPermissao } from '../services/auth';
import { secoesPermitidas } from '../componentes/parametros/secoes';
import { funcionalidadeAtiva, perfilGenerico } from '../services/configuracao';

// Fonte única da navegação por módulo. Usado pela barra lateral, pelo seletor
// de módulo do topo, pelos cards do dashboard e pelas migalhas (breadcrumb).
// Cada módulo tem uma cor de destaque (accent) que reforça a separação visual.
export const MODULOS = [
    {
        id: 'mpg-support', titulo: 'MPG Support', rotulo: 'MPG Support', cor: '#D32F2F', icone: <SupportAgentIcon />,
        itens: [
            { rota: '/support', titulo: 'Visão Geral', icone: <MonitorHeartIcon />, permissao: 'MPG_SUPPORT_DIAGNOSTICO' },
            { rota: '/support/logs', titulo: 'Logs', icone: <HistoryIcon />, permissao: 'MPG_SUPPORT_LOGS' },
            { rota: '/support/trace', titulo: 'Trace de Requisições', icone: <TimelineIcon />, permissao: 'MPG_SUPPORT_LOGS' },
            { rota: '/support/sql', titulo: 'SQL Console', icone: <TerminalIcon />, permissao: 'MPG_SUPPORT_SQL' },
            { rota: '/support/database', titulo: 'Banco de Dados', icone: <StorageIcon />, permissao: 'MPG_SUPPORT_DATABASE' },
            { rota: '/support/diagnostico', titulo: 'Diagnóstico', icone: <MonitorHeartIcon />, permissao: 'MPG_SUPPORT_DIAGNOSTICO' },
            { rota: '/support/fila', titulo: 'Diagnóstico da Fila', icone: <FormatListNumberedIcon />, permissao: 'MPG_SUPPORT_DIAGNOSTICO' },
            { rota: '/support/sessoes', titulo: 'Sessões', icone: <DevicesIcon />, permissao: 'MPG_SUPPORT_DIAGNOSTICO' },
            { rota: '/support/ferramentas', titulo: 'Ferramentas', icone: <BuildIcon />, permissao: 'MPG_SUPPORT_REPARO' },
            // MPG_SUPPORT_ACESSAR e não MPG_SUPPORT_FUNCIONALIDADES: quem entra
            // no suporte deve conseguir ver o que está ligado nesta instalação
            // ao diagnosticar um chamado. Alterar é que exige a permissão extra.
            { rota: '/support/funcionalidades', titulo: 'Funcionalidades', icone: <ToggleOnIcon />, permissao: 'MPG_SUPPORT_ACESSAR' },
            // Ver a configuração da integração é parte de diagnosticar "a importação
            // parou", então o item pede só o acesso ao módulo; cadastrar e testar
            // exigem INTEGRACAO_CONFIGURAR, checada na tela e no backend.
            { rota: '/support/integracoes', titulo: 'Integrações (ERP)', icone: <HubIcon />, permissao: 'MPG_SUPPORT_ACESSAR' },
            { rota: '/support/ia', titulo: 'Inteligência artificial', icone: <PsychologyIcon />, permissao: 'MPG_SUPPORT_IA' },
            { rota: '/support/dispositivos', titulo: 'Dispositivos', icone: <DevicesOtherIcon />, permissao: 'MPG_SUPPORT_ACESSAR' },
            // MPG_SUPPORT_ACESSAR pelo mesmo motivo de Funcionalidades: ver o
            // layout ajuda a diagnosticar "o relatório saiu torto". Alterar é
            // que exige MPG_SUPPORT_LAYOUT_RELATORIO.
            { rota: '/support/layout-relatorio', titulo: 'Layout de relatórios', icone: <PaletteIcon />, permissao: 'MPG_SUPPORT_ACESSAR' },
            { rota: '/support/relatorios-personalizados', titulo: 'Relatórios personalizados', icone: <AssessmentOutlinedIcon />, permissao: 'MPG_SUPPORT_SQL' },
        ],
    },
    {
        id: 'inicio',
        funcionalidade: 'INICIO',
        titulo: null, // sem cabeçalho na barra lateral
        rotulo: 'Início',
        cor: '#1E88E5',
        icone: <DashboardIcon />,
        itens: [
            { rota: '/dashboard', titulo: 'Dashboard', icone: <DashboardIcon />, permissao: 'DASHBOARD_VISUALIZAR' },
            // Mapa por zonas (issue #720): visão da operação, não do IntegraHub —
            // fica no início, mas só existe com as câmeras contratadas.
            { rota: '/patio/mapa', titulo: 'Pátio ao vivo', icone: <HubIcon />, permissao: 'INTEGRAHUB_VISUALIZAR', funcionalidade: 'INTEGRAHUB' },
        ],
    },
    {
        id: 'descarga',
        funcionalidade: 'DESCARGA',
        // Nome do que entra no pátio, não da operação: quem opera fala em
        // "matéria-prima", e "Descarga" sozinho não distinguia da carga no menu.
        get titulo() { return perfilGenerico() ? 'Descarga' : 'Descarga de matéria-prima'; },
        // Botão do módulo na AppBar — espaço curto, só o essencial.
        get rotulo() { return perfilGenerico() ? 'Descarga' : 'Matéria-prima'; },
        cor: '#1E88E5',
        icone: <GrassIcon />,
        itens: [
            { rota: '/fila', titulo: 'Fila', icone: <FormatListNumberedIcon />, permissao: 'FILA_DESCARGA_VISUALIZAR' },
            { rota: '/entradas', titulo: 'Entradas', icone: <HistoryIcon />, permissao: 'FILA_DESCARGA_VISUALIZAR' },
            { rota: '/movimentacoes', titulo: 'Movimentações', icone: <SwapVertIcon />, permissao: 'FILA_DESCARGA_VISUALIZAR' },
        ],
    },
    {
        id: 'carga',
        funcionalidade: 'CARGA',
        get titulo() { return perfilGenerico() ? 'Carregamento' : 'Carregamento de fécula'; },
        get rotulo() { return perfilGenerico() ? 'Carga' : 'Fécula'; },
        cor: '#00897B',
        icone: <LocalShippingIcon />,
        itens: [
            { rota: '/fila-carga', titulo: 'Fila de carga', icone: <LocalShippingIcon />, permissao: 'FILA_CARGA_VISUALIZAR' },
            // Títulos com sufixo (como "Fila de carga"): dois itens "Entradas" no
            // menu seriam ambíguos para o operador e para a busca.
            { rota: '/entradas-carga', titulo: 'Entradas da carga', icone: <HistoryIcon />, permissao: 'FILA_CARGA_VISUALIZAR' },
            { rota: '/movimentacoes-carga', titulo: 'Movimentações da carga', icone: <SwapVertIcon />, permissao: 'FILA_CARGA_VISUALIZAR' },
            { rota: '/checklists', titulo: 'Checklists', icone: <PlaylistAddCheckIcon />, permissao: 'CHECKLIST_CONSULTAR' },
            // Item do Comercial, não da Portaria: lista o que entrou sem
            // transportadora (issue #422). Fica visível mesmo na instalação que
            // exige o cadastro na chegada — carga antiga e vínculo desfeito pela
            // integração continuam caindo aqui.
            {
                rota: '/transportadora-pendente', titulo: 'Transportadora pendente',
                icone: <LocalShippingIcon />, permissao: 'FILA_CARGA_VISUALIZAR',
            },
            // Só na instalação que usa o fluxo novo de carregamento: sem a flag, o
            // back recusa as rotas e o item levaria a uma tela que não carrega.
            {
                rota: '/romaneios', titulo: 'Romaneios', icone: <DescriptionIcon />,
                permissao: 'PROCESSO_CARGA_VISUALIZAR', funcionalidade: 'NOVO_CARREGAMENTO',
            },
            // Item do Comercial (issue #456): o que o ERP mandou antes do caminhão
            // chegar. Separado de "Romaneios" de propósito — aquela é a fila de
            // trabalho de quem tem o caminhão no pátio; aqui não há carga nenhuma
            // ainda, só a expectativa de uma.
            {
                rota: '/romaneios-agendados', titulo: 'Romaneios agendados',
                icone: <EventAvailableIcon />,
                permissao: 'ROMANEIO_AGENDAR_VISUALIZAR', funcionalidade: 'ROMANEIOS_AGENDADOS',
            },
            // Documento de entrada ou saída sem caminhão na fila e sem ERP (issue #706).
            // Liberado pela funcionalidade, não pelo perfil da instalação.
            {
                rota: '/romaneios-avulsos', titulo: 'Romaneios de entrada e saída',
                icone: <SwapVertIcon />,
                permissao: 'ROMANEIO_AVULSO_VISUALIZAR', funcionalidade: 'ROMANEIO_AVULSO',
            },
        ],
    },
    // Módulo opcional: só aparece na instalação que tem balança integrada
    // (app.funcionalidades.pesagem). Sem a flag, o back nem sobe as rotas.
    {
        id: 'pesagem',
        titulo: 'Pesagem',
        rotulo: 'Pesagem',
        cor: '#5E35B1',
        icone: <ScaleIcon />,
        funcionalidade: 'PESAGEM',
        itens: [
            { rota: '/pesagem', titulo: 'Pesagens', icone: <MonitorWeightIcon />, permissao: 'PESAGEM_VISUALIZAR' },
            { rota: '/balancas', titulo: 'Balanças', icone: <ScaleIcon />, permissao: 'PESAGEM_CONFIGURAR' },
        ],
    },
    {
        id: 'integrahub', titulo: 'Reconhecimento de placas', rotulo: 'Placas', cor: '#00796B', icone: <HubIcon />,
        funcionalidade: 'INTEGRAHUB',
        itens: [
            { rota: '/integrahub/eventos', titulo: 'Leituras de placas', icone: <DevicesOtherIcon />, permissao: 'INTEGRAHUB_VISUALIZAR' },
            { rota: '/integrahub/mapa', titulo: 'Mapa de passagens', icone: <HubIcon />, permissao: 'INTEGRAHUB_VISUALIZAR' },
            { rota: '/integrahub/configuracao', titulo: 'Configurar IntegraHub', icone: <SettingsIcon />, permissao: 'INTEGRAHUB_ADMINISTRAR' },
        ],
    },
    {
        id: 'rotinas', funcionalidade: 'ROTINAS', titulo: 'Automações', rotulo: 'Rotinas', cor: '#455A64', icone: <TimelineIcon />,
        itens: [{ rota: '/rotinas', titulo: 'Rotinas do sistema', icone: <TimelineIcon />, permissao: 'ROTINAS_VISUALIZAR' }],
    },
    {
        id: 'cadastros',
        funcionalidade: 'CADASTROS',
        titulo: 'Cadastros',
        rotulo: 'Cadastros',
        cor: '#8E24AA',
        icone: <FolderIcon />,
        itens: [
            { rota: '/motoristas', titulo: 'Motoristas', icone: <PersonIcon />, permissao: 'CADASTROS_GERENCIAR' },
            { rota: '/variedades', titulo: 'Variedades', icone: <SpaIcon />, permissao: 'CADASTROS_GERENCIAR' },
            // Produto que sai no romaneio — a variedade é a mandioca que chega.
            { rota: '/produtos', titulo: 'Produtos', icone: <Inventory2Icon />, permissao: 'CADASTROS_GERENCIAR' },
            { rota: '/transportadoras', titulo: 'Transportadoras', icone: <BusinessIcon />, permissao: 'CADASTROS_GERENCIAR' },
            { rota: '/vinculos-placa', titulo: 'Vínculos de placa', icone: <LinkIcon />, permissao: 'VINCULO_PLACA_GERENCIAR' },
            // Funcionalidade própria: a impressão é opcional por instalação
            // (IMPRESSAO), e o resto de Cadastros continua valendo sem ela.
            { rota: '/impressoras', titulo: 'Dispositivos', icone: <PrintIcon />, permissao: 'CADASTROS_GERENCIAR', funcionalidade: 'IMPRESSAO' },
        ],
    },
    {
        id: 'admin',
        funcionalidade: 'ADMINISTRACAO',
        titulo: 'Administração',
        rotulo: 'Administração',
        cor: '#F57C00',
        icone: <AdminPanelSettingsIcon />,
        itens: [
            { rota: '/relatorios', titulo: 'Relatórios', icone: <AssessmentIcon />, permissao: 'RELATORIOS_VISUALIZAR', funcionalidade: 'RELATORIOS' },
            // Métricas por usuário (issue #565): as próprias ou, com permissão
            // de equipe, as de outra pessoa — uma por vez, sem ranking.
            {
                rota: '/metricas', titulo: 'Métricas por usuário', icone: <InsightsIcon />,
                visivel: () => temPermissao('METRICAS_PROPRIAS_VISUALIZAR') || temPermissao('METRICAS_EQUIPE_VISUALIZAR'),
            },
            // Subgrupo: quem entra no sistema e o que cada um pode fazer.
            {
                id: 'usuarios-perfis',
                titulo: 'Usuários e perfis',
                icone: <ManageAccountsIcon />,
                itens: [
                    { rota: '/usuarios', titulo: 'Usuários', icone: <GroupIcon />, permissao: 'USUARIOS_GERENCIAR' },
                    { rota: '/perfis', titulo: 'Perfis de acesso', icone: <AdminPanelSettingsIcon />, permissao: 'PERFIS_GERENCIAR' },
                ],
            },
            // Subgrupo: item sem rota própria, só agrupa telas de rastreabilidade.
            {
                id: 'auditoria-logs',
                titulo: 'Auditoria e logs',
                icone: <FactCheckIcon />,
                itens: [
                    { rota: '/auditoria', titulo: 'Auditoria', icone: <FactCheckIcon />, permissao: 'AUDITORIA_VISUALIZAR' },
                    { rota: '/exportacoes', titulo: 'Exportações', icone: <FileDownloadIcon />, permissao: 'AUDITORIA_VISUALIZAR', funcionalidade: 'RELATORIOS' },
                    { rota: '/downloads-backup', titulo: 'Downloads de backup', icone: <BackupIcon />, permissao: 'AUDITORIA_VISUALIZAR' },
                    { rota: '/downloads-instalador', titulo: 'Downloads de instalador', icone: <GetAppIcon />, permissao: 'AUDITORIA_VISUALIZAR' },
                ],
            },
            // Fora do subgrupo de auditoria: aqui se baixa e publica o agente e o
            // APK, não se confere rastro.
            { rota: '/instaladores', titulo: 'Instaladores', icone: <GetAppIcon />, permissao: 'INSTALADOR_BAIXAR' },
            // Chave de API é decisão de integração, não de quem opera a balança:
            // morava no módulo Pesagem, ao lado de Pesagens e Balanças, e quem
            // gerencia as chaves não tinha por que entrar lá. A flag PESAGEM
            // continua no item porque o ChaveApiController só sobe com ela e o
            // único escopo de chave hoje é a consulta de pesagens.
            {
                rota: '/chaves-api', titulo: 'Chaves de API', icone: <VpnKeyIcon />,
                permissao: 'INTEGRACAO_GERENCIAR', funcionalidade: 'PESAGEM',
            },
            // Painel simples de atendimento do MPG Assist (issue #434). Permissão
            // própria (ASSIST_ATENDER): assumir e responder conversa alheia não é
            // o mesmo poder de só poder pedir ajuda pelo widget.
            {
                rota: '/assist/atendimento', titulo: 'Atendimento (Assist)', icone: <SupportAgentIcon />,
                permissao: 'ASSIST_ATENDER', funcionalidade: 'ASSIST',
            },
            // Mesma permissão do item acima: quem atende é quem escreve o
            // texto das respostas prontas (issue #448) — ver V91.
            {
                rota: '/assist/respostas-prontas', titulo: 'Respostas prontas (Assist)', icone: <ChatBubbleOutlineIcon />,
                permissao: 'ASSIST_ATENDER', funcionalidade: 'ASSIST',
            },
            // Empresa (/empresa) e Canal de envio (/canal-entrega) saíram daqui:
            // viraram seções da central de Parâmetros (issue #424). As rotas
            // antigas continuam válidas como redirecionamento, no App.js.
            //
            // `visivel` em vez de `permissao` porque as seções não têm a mesma
            // regra: Canal de envio pede CANAL_ENTREGA_VISUALIZAR e a
            // funcionalidade NOVO_CARREGAMENTO, o resto pede
            // PARAMETROS_VISUALIZAR. Quem enxerga só o canal continua chegando
            // nele pelo menu; quem não enxerga seção nenhuma não vê o item.
            {
                rota: '/parametros', titulo: 'Parâmetros', icone: <SettingsIcon />,
                permissao: 'PARAMETROS_VISUALIZAR',
                visivel: () => secoesPermitidas().length > 0,
            },
        ],
    },
];

// Um item do módulo é subgrupo quando agrupa telas em vez de ter rota própria.
export const ehGrupo = (item) => Array.isArray(item.itens);

// A funcionalidade que controla módulo, subgrupo ou tela está ligada nesta
// instalação? Item sem `funcionalidade` só depende do módulo dono.
//
// Existe porque a flag nem sempre bate com o módulo: RELATORIOS controla duas
// telas dentro de Administração (e o back gateia os controllers por ela), e
// IMPRESSAO controla uma tela dentro de Cadastros. Filtrar só no nível do
// módulo deixava esses itens no menu levando a uma tela que responde 422 em
// toda chamada.
const disponivel = (alvo) => !alvo.funcionalidade || funcionalidadeAtiva(alvo.funcionalidade);

// A tela aparece para este perfil? Quase sempre é a permissao declarada; o item
// com `visivel` decide por conta própria, porque agrupa telas de regras
// diferentes (Parâmetros, desde que Empresa e Canal de envio viraram seções).
export const itemVisivel = (item) => (item.visivel ? item.visivel() : temPermissao(item.permissao));

// Módulos com apenas os itens que o perfil atual pode ver e que existem nesta
// instalação. Subgrupo é filtrado pelos filhos e desaparece quando sobra
// nenhum; módulos sem item permitido são descartados. Subgrupo não declara
// permissão — quem manda são as telas dentro.
// Funcionalidade vem antes da permissão: com a flag off as rotas não existem no
// back, e o item levaria a uma tela que só sabe dar erro.
export const modulosPermitidos = () => MODULOS
    .filter(disponivel)
    .map((modulo) => ({
        ...modulo,
        itens: modulo.itens
            .filter(disponivel)
            .map((item) => (ehGrupo(item)
                ? { ...item, itens: item.itens.filter((sub) => disponivel(sub) && temPermissao(sub.permissao)) }
                : item))
            .filter((item) => (ehGrupo(item) ? item.itens.length > 0 : itemVisivel(item))),
    }))
    .filter((modulo) => modulo.itens.length > 0);

// Telas navegáveis do módulo, achatando subgrupos. Os menus rápidos (seletor do
// topo e cards do dashboard) são listas planas: aninhar ali não ajudaria.
export const telasDoModulo = (modulo) =>
    (modulo?.itens || []).flatMap((item) => (ehGrupo(item) ? item.itens : [item]));

// Funcionalidades que controlam uma rota, da mais externa para a mais interna
// (módulo, subgrupo, tela). Lista vazia quando nada a controla — rota fora de
// módulo (login, painel, MPG Support) ou módulo e tela sem flag.
//
// São várias e não uma só porque a tela pode ter flag própria além da do
// módulo: /relatorios depende de ADMINISTRACAO (o módulo) e de RELATORIOS (o
// controller). Desligar qualquer uma das duas tira a tela do ar.
//
// Match por prefixo para cobrir rota de detalhe (/motoristas/12/editar).
export const funcionalidadesDaRota = (pathname) => {
    const { modulo, grupo, item } = localizarRota(pathname);
    return [modulo, grupo, item]
        .filter((alvo) => alvo?.funcionalidade)
        .map((alvo) => alvo.funcionalidade);
};

// A rota está disponível nesta instalação? Só olha funcionalidade — permissão é
// checada à parte.
//
// Existe porque esconder o item do menu não basta: quem digita a URL, tem o
// link salvo ou volta pelo histórico chegaria numa tela cujo back-end responde
// 422 em toda chamada.
export const rotaDisponivel = (pathname) =>
    funcionalidadesDaRota(pathname).every((codigo) => funcionalidadeAtiva(codigo));

// Primeira tela que o perfil atual consegue abrir de fato.
//
// Necessária porque todo módulo pode ser desligado, inclusive o Início. Sem
// isto, um perfil cuja tela inicial pertence a módulo desligado seria mandado
// para uma rota indisponível, que o manda de volta para a tela inicial — laço
// de redirecionamento.
export const primeiraTelaDisponivel = () => {
    for (const modulo of modulosPermitidos()) {
        const tela = telasDoModulo(modulo)[0];
        if (tela) return tela.rota;
    }
    return null;
};

// Casa a rota atual com módulo/subgrupo/item (destino da migalha e do realce da
// barra lateral). Faz match por prefixo para rotas de detalhe. `grupo` é null
// quando a tela não está dentro de um subgrupo.
export const localizarRota = (pathname) => {
    const casa = (item) => pathname === item.rota
        || (item.rota !== '/support' && pathname.startsWith(`${item.rota}/`));
    for (const modulo of MODULOS) {
        for (const item of modulo.itens) {
            if (ehGrupo(item)) {
                const sub = item.itens.find(casa);
                if (sub) return { modulo, grupo: item, item: sub };
            } else if (casa(item)) {
                return { modulo, grupo: null, item };
            }
        }
    }
    return { modulo: null, grupo: null, item: null };
};
